<div class="container-fluid q-police q-bo-group" style="display:block;">
  <div col="row no-gutters">
    <div class="col-12 p-0">
      <h5 class="q-bo-grouptitle" (click)="itemGrp.showTpl = true">{{title}}</h5>
    </div>
  </div>
  <ng-container *ngFor="let input of item; let i = index" >
    <ng-container *ngIf="input.Visible">
      <div class="row no-gutters">
        <div class="col-12">
          <label *ngIf="IsVisible(input)" id="{{input?.MainLabel?.ID}}" class="q-bo-label" (click)="methodLabel(input.MainLabel?.OnClick)">{{input.MainLabel.Value}} :</label>
          <q-dynamictag class="w-100" [ModeBo]="modeBo" [Model]="model" [(item)]="item[i]" [title]="title" [parent]="parent" (sendBreadcrumb)="getBreadcrump($event)"></q-dynamictag>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
